import { Pipe, type PipeTransform } from "@angular/core";

@Pipe({
    name: "appFlagToString",
    standalone: true,
})
export class FlagToStringPipe implements PipeTransform {
    transform(value: number, enumType: Record<string, string | number>): string {
        const validKeys = Object.keys(enumType).filter((x) => !isNaN(Number(enumType[x])));
        const keys = validKeys.filter((x) => (value & (enumType[x] as number)) === enumType[x]);

        return keys.filter((x) => !exclude.includes(x)).join(", ");
    }
}

const exclude = ["None", "Undefined", "All"];
